import { ItemList } from '../../orm'

class AdminOutboundEmailList extends ItemList {
    getEntityKey() {
        return "admin/outbound_email"
    }
}

export const adminOutboundEmailList = new AdminOutboundEmailList("admin_outbound_email__default")
